import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const SpFrame: FC<Props> = (props) => {
  return (
    <Root viewBox="0 0 90.026 171.097" {...props}>
      <g data-name="\u30B0\u30EB\u30FC\u30D7 499" transform="translate(-141.983 -340.997)">
        <path
          data-name="\u30D1\u30B9 1259"
          d="M155 340.998h64.077a12.953 12.953 0 0112.932 13l-.013 144.959c0 6.145-4.687 13.137-10.764 13.137h-68.476c-6.077 0-10.751-6.986-10.751-13.13l-.022-144.959A12.911 12.911 0 01155 340.998z"
        />
        <path
          data-name="\u30D1\u30B9 1197"
          d="M219.101 344.894h-8.875v1.2a4.733 4.733 0 01-4.7 4.761h-36.661a4.734 4.734 0 01-4.706-4.761v-1.2h-9.258a9.077 9.077 0 00-8.9 9.121h82.01a9.036 9.036 0 00-8.91-9.121z"
          fill="#fff"
        />
        <path
          data-name="\u30D1\u30B9 1258"
          d="M145.991 499a8.565 8.565 0 008.88 8.539h64.085c4.9 0 9.058-3.581 9.058-8.539h-82.023z"
          fill="#fff"
        />
        <rect
          data-name="\u9577\u65B9\u5F62 976"
          width={21.795}
          height={2.211}
          rx={0.902}
          transform="translate(174.973 503)"
        />
      </g>
    </Root>
  );
};

const Root = styled('svg')({
  fill: '#333',
});

export default SpFrame;
